// mixpanel project token
export const mixpanelProjectToken =
  process.env.QC_MIXPANEL_TOKEN || '609e9df2e8a6240099c8643021babdce'
